import { defineMessages } from "react-intl";

const baseId = "t.components.modals.caMobileResponseModal.";

export default defineMessages({
  pendingTitle: {
    id: baseId + "pendingTitle",
    defaultMessage: "Pending...",
  },
  errorTitle: {
    id: baseId + "errorTitle",
    defaultMessage: "Access negated",
  },
  successTitle: {
    id: baseId + "successTitle",
    defaultMessage: "Authorized access",
  },
  errorBodyContent: {
    id: baseId + "errorBodyContent",
    defaultMessage: "The inserted OTP is invalid or exipired, please try again",
  },
  pendingBodyContent: {
    id: baseId + "pendingBodyContent",
    defaultMessage: "Waiting...",
  },
  successBodyContent: {
    id: baseId + "successBodyContent",
    defaultMessage: "Login authorized, proceed to UIGP",
  },
  close: {
    id: baseId + "close",
    defaultMessage: "Close",
  },
});
